import { render, staticRenderFns } from "./StudentsWithMaterials.vue?vue&type=template&id=71b0b9fa&scoped=true"
import script from "./StudentsWithMaterials.vue?vue&type=script&lang=js"
export * from "./StudentsWithMaterials.vue?vue&type=script&lang=js"
import style0 from "./StudentsWithMaterials.vue?vue&type=style&index=0&id=71b0b9fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0b9fa",
  null
  
)

export default component.exports